import Loading from 'shared/components/Loading';

const Loading2 = props => {
  const {
    message
  } = props;

  const style = {
    position: 'absolute',
    zIndex: 99999,
    top: 0,
    textAlign: 'center',
    marginTop: '8rem'
  }

  const msgStyle = {
    fontFamily: 'sans-serif !important',
    fontSize: '1rem',
    marginTop: '1rem'
  }

  return <Loading style={style} messageStyle={msgStyle} message={message} />;
}

export default Loading2;
